import { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";
import { IoIosArrowForward } from "react-icons/io";

const Blog = () => {
  const [selectedCategory, setSelectedCategory] = useState("all");

  const blogPosts = [
    {
      id: 1,
      title: "Apple Vision Pro: El futuro de la computación espacial",
      date: "28 Dic 2024",
      category: "dispositivos",
      image:
        "https://www.apple.com/newsroom/images/2024/01/apple-vision-pro-available-in-the-us-on-february-2/article/Apple-Vision-Pro-availability-hero_big.jpg.large.jpg",
      excerpt:
        "El Apple Vision Pro representa un salto revolucionario en la realidad mixta, combinando realidad virtual y aumentada en una experiencia única.",
      readTime: "5 min",
    },
    {
      id: 2,
      title: "Samsung Galaxy S24: La nueva era de la IA en smartphones",
      date: "27 Dic 2024",
      category: "smartphones",
      image:
        "https://img.global.news.samsung.com/mx/wp-content/uploads/2024/01/Galaxy-S24-Series_main4.jpg",
      excerpt:
        "Samsung integra funciones avanzadas de inteligencia artificial en su nueva línea Galaxy S24, revolucionando la fotografía móvil y la traducción en tiempo real.",
      readTime: "4 min",
    },
    {
      id: 3,
      title: "Baterías de Estado Sólido: El futuro de la carga rápida",
      date: "26 Dic 2024",
      category: "innovacion",
      image:
        "https://i.kinja-img.com/image/upload/c_fit,q_60,w_645/3cabc273c3b26947016099b133c3705c.jpg",
      excerpt:
        "Las nuevas baterías de estado sólido prometen revolucionar la industria móvil con tiempos de carga de apenas 10 minutos y mayor durabilidad.",
      readTime: "6 min",
    },
    {
      id: 4,
      title: "Los mejores accesorios para proteger tu smartphone",
      date: "25 Dic 2024",
      category: "accesorios",
      image:
        "https://mandalacases.com/cdn/shop/articles/accesorios-para-celulares-mandala-cases.jpg?v=1633406350",
      excerpt:
        "Guía completa de los accesorios más innovadores para mantener tu teléfono seguro y aprovechar al máximo sus funciones.",
      readTime: "3 min",
    },
  ];

  const categories = [
    { id: "all", name: "Todos" },
    { id: "smartphones", name: "Smartphones" },
    { id: "dispositivos", name: "Dispositivos" },
    { id: "innovacion", name: "Innovación" },
    { id: "accesorios", name: "Accesorios" },
  ];

  const filteredPosts =
    selectedCategory === "all"
      ? blogPosts
      : blogPosts.filter((post) => post.category === selectedCategory);

  return (
    <div className="w-full min-h-screen bg-white">
      <Header />

      <section className='bg-[url("https://diarcel.com/images/banner/shop.png")] h-[220px] bg-cover bg-no-repeat relative bg-left'>
        <div className="absolute left-0 top-0 w-full h-full bg-[#2422228a]">
          <div className="w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto">
            <div className="flex flex-col justify-center gap-1 items-center h-full w-full text-white">
              <h2 className="text-3xl font-bold">Blog Tecnologico</h2>
              <div className="flex justify-center items-center gap-2 text-2xl w-full">
                <Link to="/">Inicio</Link>
                <span className="pt-1">
                  <IoIosArrowForward />
                </span>
                <span>Blog</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Category Filter */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex flex-wrap gap-4 justify-center">
          {categories.map((category) => (
            <button
              key={category.id}
              onClick={() => setSelectedCategory(category.id)}
              className={`px-4 py-2 rounded-full transition-colors ${
                selectedCategory === category.id
                  ? "bg-[#059473] text-white"
                  : "bg-white text-gray-700 hover:bg-gray-100"
              } shadow-sm`}
            >
              {category.name}
            </button>
          ))}
        </div>
      </div>

      {/* Blog Posts Grid */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredPosts.map((post) => (
            <article
              key={post.id}
              className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow"
            >
              <img
                src={post.image}
                alt={post.title}
                className="w-full h-48 object-cover"
              />
              <div className="p-6">
                <div className="flex items-center gap-4 mb-4">
                  <span className="text-sm text-gray-700">{post.date}</span>
                  <span className="text-sm text-gray-700">•</span>
                  <span className="text-sm text-gray-700">
                    {post.readTime} de lectura
                  </span>
                </div>
                <h2 className="text-xl font-bold mb-3 text-gray-900">
                  {post.title}
                </h2>
                <p className="text-gray-600 mb-4">{post.excerpt}</p>
                {/* <button className="text-[#059473] font-semibold hover:text-green-700 transition-colors">
                  Leer más →
                </button> */}
              </div>
            </article>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Blog;
